import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeVendorShipmentConfig } from './normalize';

export const fetchVendorShipmentConfig = createProvider(api.fetchVendorShipmentConfig)
  .andThen((res) => normalizeVendorShipmentConfig(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch fetchVendorShipmentConfigList aborted');
    } else {
      console.error('Fetch fetchVendorShipmentConfigList was failed:', error);
    }
    throw error;
  });
